/**
 * DateInput Component
 * 텍스트 타이핑과 캘린더 선택을 모두 지원하는 날짜 입력 컴포넌트
 */
import React from "react";

interface DateInputProps {
    id: string;
    value: string;
    onChange: (value: string) => void;
    onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    placeholder?: string;
    className?: string;
    disabled?: boolean;
    min?: string;       // 최소 날짜 (YYYY-MM-DD 형식)
    max?: string;       // 최대 날짜 (YYYY-MM-DD 형식)
}

const DateInput: React.FC<DateInputProps> = ({
    id,
    value,
    onChange,
    onKeyPress,
    placeholder = "YYYY-MM-DD",
    className = "form-input",
    disabled = false,
    min,
    max
}) => {
    return (
        <div className="date-input-wrapper">
            <input
                type="text"
                className={className}
                placeholder={placeholder}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onKeyPress={onKeyPress}
                disabled={disabled}
                min={min}
                max={max}
            />
            <input
                type="date"
                id={id}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onKeyPress={onKeyPress}
                disabled={disabled}
                min={min}
                max={max}
            />
            <i
                className="fas fa-calendar calendar-icon"
                onClick={() => {
                    if (!disabled) {
                        const input = document.getElementById(id) as HTMLInputElement;
                        input?.showPicker?.();
                    }
                }}
                style={{ cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.5 : 1 }}
            />
        </div>
    );
};

export default DateInput;
